import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["adjustedUnitPrice", "percentage", "source"]
  static values = {
    unitPrice: { type: Number, default: 0 }
  }

  connect() {
    this.updateNegativeStyles()
  }

  useAdjustedUnitPrice() {
    this.setSource("adjusted_unit_price")
    this.syncPercentage()
    this.updateNegativeStyles()
  }

  usePercentage() {
    this.setSource("adjusted_unit_price_percentage")
    this.syncAdjustedUnitPrice()
    this.updateNegativeStyles()
  }

  setSource(value) {
    if (!this.hasSourceTarget) return

    this.sourceTarget.value = value
  }

  syncPercentage() {
    if (!this.hasAdjustedUnitPriceTarget || !this.hasPercentageTarget) return

    const adjustedUnitPrice = Number.parseFloat(this.adjustedUnitPriceTarget.value)
    if (Number.isNaN(adjustedUnitPrice)) return

    if (this.unitPriceValue === 0) {
      this.percentageTarget.value = "0.00"
      return
    }

    const percentage = ((adjustedUnitPrice - this.unitPriceValue) / this.unitPriceValue) * 100
    this.percentageTarget.value = percentage.toFixed(2)
  }

  syncAdjustedUnitPrice() {
    if (!this.hasAdjustedUnitPriceTarget || !this.hasPercentageTarget) return

    const percentage = Number.parseFloat(this.percentageTarget.value)
    if (Number.isNaN(percentage)) return

    const adjustedUnitPrice = this.unitPriceValue * (1 + (percentage / 100))
    this.adjustedUnitPriceTarget.value = adjustedUnitPrice.toFixed(2)
  }

  updateNegativeStyles() {
    this.updateNegativeStyle(this.percentageTarget)
  }

  updateNegativeStyle(field) {
    if (!field) return

    const value = Number.parseFloat(field.value)
    const isNegative = !Number.isNaN(value) && value < 0
    field.classList.toggle("text-red-600", isNegative)
    field.classList.toggle("font-semibold", isNegative)
  }
}
